import { Injectable, inject, Signal } from '@angular/core';
import { Store } from '@ngrx/store';
import { Language } from '@lyceo/homi/settings/util-models';
import * as SettingsSelectors from './settings.selectors';
import { SettingsPageActions } from './settings.actions';

@Injectable({
  providedIn: 'root',
})
export class SettingsFacade {
  private readonly store: Store = inject(Store);

  public readonly language: Signal<Language> = this.store.selectSignal(
    SettingsSelectors.selectLanguage,
  );

  public languageChanged(language: Language): void {
    this.store.dispatch(SettingsPageActions.languageChanged({ language }));
  }
}
